import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { showAlert } from '../../utility/SweetAlert'
import ApiService from '../../services/ApiService'

const InteractorProoductMedia = () => {
  const { t } = useTranslation()
  const [productMediaLoading, setProductMediaLoading] = useState(false)
  const addProductMedia = useCallback(
    (payload) => {
      let payloadRequest = { ...payload }
      setProductMediaLoading(true)
      ApiService.jsonRequest('/product-media/create', payloadRequest, (response) => {
        setProductMediaLoading(false)
        showAlert({
          icon: response.status_code === 200 ? 'success' : 'error',
          message: t(
            `response_message.${
              response.status_code === 200 ? 'data_has_been_added' : response.messages
            }`,
          ),
          timer: false,
        })
      })
    },
    [t],
  )

  const deleteProductMedia = useCallback(
    (payload) => {
      let payloadRequest = { ...payload }
      setProductMediaLoading(true)
      ApiService.jsonRequest('/product-media/delete', payloadRequest, (response) => {
        setProductMediaLoading(false)
        showAlert({
          icon: response.status_code === 200 ? 'success' : 'error',
          message: t(
            `response_message.${
              response.status_code === 200 ? 'data_has_been_deleted' : response.messages
            }`,
          ),
          timer: false,
        })
      })
    },
    [t],
  )

  const updateProductMedia = useCallback(
    (payload) => {
      let payloadRequest = { ...payload }
      setProductMediaLoading(true)
      ApiService.jsonRequest('/product-media/update', payloadRequest, (response) => {
        setProductMediaLoading(false)
        showAlert({
          icon: response.status_code === 200 ? 'success' : 'error',
          message: t(
            `response_message.${
              response.status_code === 200 ? 'data_has_been_updated' : response.messages
            }`,
          ),
          timer: false,
        })
      })
    },
    [t],
  )

  return { productMediaLoading, addProductMedia, deleteProductMedia, updateProductMedia }
}

export default InteractorProoductMedia
